import React from 'react';
import { Link } from 'react-router-dom';

export default function Button({ 
    children, 
    onClick, 
    to,
    variant = 'default',
    className = '',
    disabled = false,
    type = 'button'
}) {
    const baseStyles = 'inline-flex h-12 items-center justify-center rounded-md px-6 font-medium shadow-lg transition active:scale-95 font-body';
    
    const variants = {
        default: 'bg-forest text-white shadow-forest/20 hover:bg-leaf',
        primary: 'bg-forest text-white shadow-forest/20 hover:bg-leaf',
        secondary: 'bg-offwhite text-charcoal shadow-charcoal/20 hover:bg-leaf border border-sage',
        danger: 'bg-red-600 text-white shadow-red-500/20 hover:bg-red-700',
        success: 'bg-leaf text-white shadow-leaf/20 hover:bg-forest',
    };

    const disabledStyles = 'opacity-50 cursor-not-allowed pointer-events-none';

    const buttonClasses = `${baseStyles} ${variants[variant]} ${disabled ? disabledStyles : ''} ${className}`;

    // If 'to' prop is provided, render as Link
    if (to) {
        return (
            <Link to={to} className={buttonClasses}>
                {children}
            </Link>
        );
    }

    // Otherwise render as button
    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled}
            className={buttonClasses}
        >
            {children}
        </button>
    );
}
